import { ArrowRight, Column, IconButton, Row, Typography } from '@viewup/ui';
import type { ReactNode } from 'react';

interface AccountMenuButtonProps {
  badge?: ReactNode;
  content: string;
  onClick?: () => void;
  title: string;
}
export const AccountMenuButton = (props: AccountMenuButtonProps) => {
  const { onClick, title, content, badge } = props;
  return (
    <Row
      alignItems='center'
      border='1 solid border.secondary'
      br={8}
      css={{
        cursor: 'pointer',
      }}
      justifyContent='space-between'
      px={16}
      py={12}
      {...(onClick && { onClick })}
    >
      <Row alignItems='center' gap={12}>
        <Column gap={4}>
          <Typography color='text.tertiary' fontType='caption.regular'>
            {content}
          </Typography>
          <Row alignItems='center' gap={8}>
            <Typography color='text.primary' fontType='body2.medium'>
              {title}
            </Typography>
            {badge}
          </Row>
        </Column>
      </Row>

      <IconButton size='XS' variant='ghost.assistive'>
        <ArrowRight />
      </IconButton>
    </Row>
  );
};
